import { Modal, Select, SelectOption, Button, BuildingIcon } from "@mwi/ui";
import { useForm } from "react-hook-form";
import { useGetPracticesQuery, useSwitchPracticeMutation } from "api";
import { To } from "react-router-dom";

type Inputs = {
  practice: string;
};

const SwitchPracticeModal = ({
  isOpen,
  onClose,
  redirectLocation,
}: {
  isOpen: boolean;
  onClose: () => void;
  redirectLocation: To;
}): JSX.Element => {
  const { control, handleSubmit } = useForm<Inputs>();

  const { data: practices, isLoading } = useGetPracticesQuery({
    filtering: { search_term: undefined, status: undefined },
    sorting: { sort_by: undefined },
  });

  const [switchPractice, { isLoading: isSwitching }] =
    useSwitchPracticeMutation();

  const handleFormSubmit = async (data) => {
    await switchPractice(data.practice).unwrap();
    window.location.assign(redirectLocation.toString());
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="!max-w-[736px] overflow-y-visible"
    >
      <Modal.Header title="Select vet practice" />

      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Modal.Content>
          <p className="mb-10">
            To access this page, you first need to choose the vet practice for
            which you wish to see information.
          </p>

          <div className="flex items-center justify-between gap-6">
            <div className="w-full">
              <Select
                name="practice"
                control={control}
                prefixIcon={<BuildingIcon />}
                placeholder="Select a practice"
                loading={isLoading}
              >
                {practices?.map((p) => (
                  <SelectOption key={p.id} value={p.id.toString()}>
                    {p.display_name}
                  </SelectOption>
                ))}
              </Select>
            </div>

            <Button
              type="submit"
              disabled={isLoading}
              loading={isSwitching}
              className="whitespace-nowrap"
            >
              Confirm
            </Button>
          </div>
        </Modal.Content>
      </form>
    </Modal>
  );
};

export default SwitchPracticeModal;
